import React, { useState } from "react";
import { Layout, Button, Modal } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ImageUrl } from "../../helpers/Functions";
import "./b2b-training.css";

function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [modal2Open, setModal2Open] = useState(false);

  React.useEffect(() => {
    if (!user && !token) {
      navigate("/", { replace: true });
    }
  }, [user, token, navigate]);

  const stories = [
    {
      id: 1,
      title:
        "Transforming Training: How RTI Thrived with WrightCo Academy's LMS",
      image: "new-92.png",
    },
    {
      id: 2,
      title: "Innovative Learning: Revolutionizing Employee Development",
      image: "new-93.png",
    },
    {
      id: 3,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-94.png",
    },
    {
      id: 4,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-95.png",
    },
    {
      id: 5,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-96.png",
    },
    {
      id: 6,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-97.png",
    },
    {
      id: 7,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-98.png",
    },
    {
      id: 8,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-99.png",
    },
    {
      id: 9,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-100.png",
    },
    {
      id: 10,
      title: "Scaling Excellence: The Future of Online Education",
      image: "new-101.png",
    },
  ];

  return (
    <Layout className="b2b-page">
      <section
        className="b2b-hero"
        style={{ backgroundImage: `url(${ImageUrl("new-90.png")})` }}
      >
        <div className="b2b-hero-overlay" aria-hidden />
        <div className="b2b-wrap b2b-hero-inner">
          <div className="b2b-hero-copy">
            <span className="b2b-hero-badge">CUSTOMER STORIES</span>
            <h1 className="fontFamily1 b2b-hero-title">
              Read How Our Customers Manage Training And{" "}
              <span>Grow Their Businesses</span>
            </h1>
            <p className="fontFamily1 b2b-hero-sub">
              Learn how our customers manage professional development with AOM:
              Training Customers, Businesses, and Employees. Say no more to
              cookie-cutter platforms with poor support!
            </p>
            <div className="b2b-hero-actions">
              {!token && (
                <Button
                  type="primary"
                  className="b2b-hero-btn-primary"
                  onClick={() => navigate("/signup")}
                >
                  Register Now
                </Button>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--white">
        <div className="b2b-wrap">
          <div className="b2b-section-intro">
            <span className="b2b-section-kicker">
              <img src={ImageUrl("miniImg2.png")} alt="" />
            </span>
            <h2 className="fontFamily1 b2b-section-title">
              What Do Customers Love About WrightCo Academy?
            </h2>
          </div>
          <div
            className="b2b-split-media"
            style={{ maxWidth: 900, margin: "0 auto" }}
          >
            <img src={ImageUrl("new-91.png")} alt="" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--muted">
        <div className="b2b-wrap">
          <div className="b2b-section-intro">
            <span className="b2b-section-kicker">
              <img src={ImageUrl("miniImg2.png")} alt="" />
            </span>
            <h2 className="fontFamily1 b2b-section-title">
              More Customer Stories
            </h2>
            <p className="fontFamily1 b2b-section-lead">
              Read how our customers use WrightCo Academy to manage eLearning,
              scale Professional Development, and sell courses B2B and B2C.
            </p>
          </div>

          <div className="b2b-story-grid">
            {stories.map((story) => (
              <Link
                key={story.id}
                target="_blank"
                rel="noopener noreferrer"
                to="https://wrightcoblog.com/"
                className="b2b-story-card"
              >
                <div className="b2b-story-card-media">
                  <img
                    src={ImageUrl(story.image)}
                    alt=""
                    loading="lazy"
                  />
                </div>
                <div className="b2b-story-card-body">
                  <h3>{story.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--white">
        <div className="b2b-wrap">
          <div className="b2b-cta-banner">
            <h2 className="fontFamily1">
              Efficiently Sell Courses & Webinars Online
            </h2>
            {!token && (
              <Button
                className="b2b-btn-light"
                onClick={() => navigate("/signup")}
                style={{ marginTop: 0 }}
              >
                Get Started
              </Button>
            )}
          </div>
        </div>
      </section>

      <section className="b2b-trainer">
        <div className="b2b-wrap">
          <div className="b2b-trainer-card">
            <h3>We&apos;re Looking for Trainers</h3>
            <h3>Teach. Create. Earn.</h3>
            <p>
              Are you passionate about teaching? Ready to share your expertise,
              connect with professionals, and make a meaningful impact, all
              while earning extra income?
            </p>

            <h4>You&apos;ve come to the right place.</h4>
            <p>
              At WrightCo Academy, we are building a network of world-class
              trainers and industry experts dedicated to developing high-quality
              courseware for professionals in early care and education. If
              you&apos;re an expert in your field with a desire to teach,
              we&apos;d love to have you on board!
            </p>

            <h3>Why Join Us?</h3>
            <ul>
              <li>
                <p>
                  ✅ Expand Your Reach – Share your knowledge with a broad
                  audience of professionals.
                </p>
              </li>
              <li>
                <p>
                  ✅ Boost Your Visibility – Gain recognition as a trusted expert
                  in your industry.
                </p>
              </li>
              <li>
                <p>
                  ✅ Join a Thriving Community – Connect with like-minded trainers
                  and industry leaders.
                </p>
              </li>
              <li>
                <p>
                  ✅ Earn Passive Income – Our fair and flexible revenue-sharing
                  model ensures unlimited earning potential.
                </p>
              </li>
            </ul>

            <h3>What It Takes to Be a WrightCo Trainer</h3>
            <ul>
              <li>
                <p>
                  ✔ <strong>Passion for Teaching</strong> – A commitment to
                  sharing knowledge and empowering others.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Industry Expertise</strong> – Relevant certifications
                  and experience in your domain.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Strong Communication Skills</strong> – Ability to
                  present information effectively.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Commitment to Excellence</strong> – Willingness to
                  develop and deliver high-quality training.
                </p>
              </li>
            </ul>
            <h4>Ready to Make an Impact?</h4>
            <p>
              Join WrightCo Academy today and take the next step in your teaching
              journey.
            </p>
          </div>
        </div>
      </section>

      <Modal
        className="b2b-video-modal"
        centered
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        width={1000}
        footer={false}
      >
        <div style={{ padding: "24px 12px" }}>
          <video width="auto" height="auto" controls>
            <source src="https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4" />
            <source src="movie.ogg" type="video/ogg" />
          </video>
        </div>
      </Modal>
    </Layout>
  );
}

export default Homepage;
